import styles from './protocols.module.css';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pageTitle/PageTitle';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import Footer from '../../components/footer/Footer';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { CiSearch } from 'react-icons/ci';
import axiosRequest from '../../services/axios/axiosRequest';
import DOMPurify from 'dompurify';


export default function Protocols() {

  const navigateTo = useNavigate();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isLoading, setIsLoading] = useState(true);
  const allProtocolsRef = useRef([]);
  const [protocols, setProtocols] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const protocolsController = new AbortController();
    axiosRequest.get('/protocols/', { signal: protocolsController.signal })
      .then(res => {
        allProtocolsRef.current = res.data;
        setProtocols(res.data);
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false));

    const handleMouseMove = (event) => {
      setMousePosition({ x: event.clientX, y: event.clientY, });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      protocolsController.abort();
      window.removeEventListener("mousemove", handleMouseMove);
    }
  }, []);

  function handleSearch(event) {
    const content = event.target.value;
    setSearchTerm(content);
    const filteredProtocols = allProtocolsRef.current.filter(protocol =>
      protocol.title.toLowerCase().includes(content.trim().toLowerCase())
      ||
      protocol.description.toLowerCase().includes(content.trim().toLowerCase()));
    setProtocols(filteredProtocols);
  }

  function handleLearnMore(event, slug) {
    event.stopPropagation();
    navigateTo(`/protocols/${slug}`);
  }

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function highlightText(text, searchTerm) {
    if (!searchTerm) return text;
    const escapedSearchTerm = escapeRegExp(searchTerm);
    const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
    return text.split(regex).map((part, index) =>
      regex.test(part) ? <span key={index} className={styles.highlight}>{part}</span> : part
    );
  }

  function extractTextFromHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  return (
    <>
      <Helmet>
        <title>پروتکل ها - نوآوران پژوه</title>
        <meta name='description' content='پروتکل های آزمایشگاهی و تحقیقاتی ارائه شده توسط شرکت نوآوران پژوه' />
      </Helmet>

      <Header />
      <main className='mainContainer container-lg'>
        <PageTitle title='پروتکل ها' className='d-sm-none' titleStyle={{ paddingBottom: 0 }} style={{ marginBottom: '1.5rem' }} />
        <div className={styles.content}>

          <div className={`${styles.search_container} d-flex d-sm-none align-items-center px-2 rounded-pill`}>
            <input className={styles.search} type='search' placeholder="جستجوی پروتکل..." onChange={handleSearch} />
            <CiSearch className={styles.searchIcon} />
          </div>

          <div className={`${styles.bannerGraphics} d-none d-sm-flex`}>
            <PageTitle title='پروتکل ها' className='mt-0 mb-0' titleStyle={{ paddingBottom: 0 }} style={{ marginBottom: '1.5rem' }} />
            <div className={`${styles.floatingObject} ${styles.object1}`} style={{ transform: `translate(${mousePosition.x * 0.2}px, ${mousePosition.y * 0.05}px)`, }}></div>
            <div className={`${styles.floatingObject} ${styles.object2}`} style={{ transform: `translate(${mousePosition.x * -0.2}px, ${mousePosition.y * -0.05}px)`, }}></div>
            <div className={`${styles.search_container} d-flex align-items-center px-2 rounded-3`}>
              <input className={styles.search} type='search' placeholder="جستجوی پروتکل..." onChange={handleSearch} />
              <CiSearch className={styles.searchIcon} />
            </div>
          </div>

          {isLoading ?
            <div className={styles.protocols_container}>
              {Array.from({ length: 20 }).map((_, index) =>
                <div className={styles.cardSkeleton} key={index}>
                  <div className={styles.titleSkeleton}></div>
                  <div className={styles.descriptionSkeleton}></div>
                  <div className={styles.buttonSkeleton}></div>
                </div>
              )}
            </div>
            :
            <>
              <div className={styles.protocols_container}>
                <AnimatePresence>
                  {protocols.map(protocol =>
                    <motion.div className={styles.protocolCard} key={protocol.id}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      transition={{ duration: 0.4, ease: "easeOut" }}
                    >
                      <h3 className={`${styles.title} text-truncate`}>{highlightText(protocol.title, searchTerm)}</h3>

                      <p className={styles.description}>
                        {highlightText(extractTextFromHTML(DOMPurify.sanitize(protocol.description)), searchTerm).length >= 150 ?
                          `${highlightText(extractTextFromHTML(DOMPurify.sanitize(protocol.description)), searchTerm).substring(0, 150)}...`
                          :
                          `${highlightText(extractTextFromHTML(DOMPurify.sanitize(protocol.description)), searchTerm)}...`}
                      </p>

                      <Button className={styles.learnMoreBtn} variant='outlined' color='primary' onClick={event => handleLearnMore(event, protocol.slug)}>
                        بیشتر بخوانید
                      </Button>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
              {protocols.length === 0 && <p className='text-center text-danger'>پروتکلی یافت نشد!</p>}
            </>
          }
        </div>
      </main >
      <Footer />
    </>
  )
}
